import { Box } from "@mui/material";
import {  logo  } from '@frontend/assets';

export const Home = () => {
  return (
  <Box 
  height="calc(100vh - 64px)"
  bgcolor="primary.main"
  display="flex"
  alignItems="center"
  justifyContent="center"
  >
    <img width="20%" src={logo} />
  </Box>
)}
